/**
 * QueryClient único de Marker (T018): `retry` 1 y `staleTime` 10 s, misma política que Staff.
 * Un `ApiError` 4xx del catálogo (`contracts/errors.md`) no se reintenta: la respuesta no va a
 * cambiar. Los `NetworkError` y los 5xx sí se reintentan una vez. Sin `refetchOnWindowFocus`: el
 * kiosco resincroniza por `visibilitychange` a través del canal, no de las queries.
 */
import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './client';

export const QUERY_STALE_TIME_MS = 10_000;
export const QUERY_RETRY = 1;

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status < 500) {
    return false;
  }
  return failureCount < QUERY_RETRY;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: QUERY_STALE_TIME_MS,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = createQueryClient();
